import posthog from "posthog-js";

const key = process.env.REACT_APP_POSTHOG_KEY;
const host = process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com";

if (key) {
  posthog.init(key, {
    api_host: host,
    capture_pageview: "history_change",
    person_profiles: "identified_only",
  });
}

export default posthog;
